import React from 'react';

function AvisoLegal() {
  return (
    <div className="min-h-safe-screen bg-[#fff]">
      <div className="max-w-3xl mx-auto px-6 py-8 pb-24">
        <h1 className="text-[var(--Color-Grays-Gray-10,#0D0C07)] text-[28px] font-bold leading-[36px] mb-2">
          Aviso Legal
        </h1>
        <p className="text-[#878683] text-[14px] mb-8">
          Última actualización: 12 de abril de 2026
        </p>

        <div className="prose prose-gray max-w-none">

          {/* ── 1. Datos identificativos (LSSI-CE Art. 10) ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">1. Datos Identificativos del Prestador</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa a los usuarios de los siguientes datos del titular del sitio web <strong>9meals.ai</strong>:
          </p>
          <ul className="list-none pl-0 mb-6 space-y-1">
            <li className="text-[16px] leading-[28px]"><strong>Razón social:</strong> Good UX OÜ</li>
            <li className="text-[16px] leading-[28px]"><strong>Número de registro:</strong> 16529659 (Registro Mercantil de Estonia — <em>Äriregister</em>)</li>
            <li className="text-[16px] leading-[28px]"><strong>Domicilio social:</strong> Harju maakond, Tallinn, Kesklinna linnaosa, Vesivärava tn 50-201, 10152, Estonia</li>
            <li className="text-[16px] leading-[28px]"><strong>Correo electrónico:</strong> <a href="mailto:hello@9meals.ai" className="text-[#006600] underline">hello@9meals.ai</a></li>
            <li className="text-[16px] leading-[28px]"><strong>Sitio web:</strong> <a href="https://9meals.ai" className="text-[#006600] underline">https://9meals.ai</a></li>
          </ul>
          <p className="text-[16px] leading-[28px] mb-6">
            Good UX OÜ es una sociedad de responsabilidad limitada (<em>osaühing</em>) constituida conforme al derecho estonio y registrada en el Registro Mercantil de Estonia. Al ofrecer servicios de la sociedad de la información a usuarios en España, queda sujeta a las obligaciones de la LSSI-CE según lo dispuesto en su artículo 4.
          </p>

          {/* ── 2. Objeto ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">2. Objeto del Sitio Web</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            El sitio web 9meals.ai proporciona un servicio de planificación de comidas asistido por inteligencia artificial, generación de listas de la compra y funcionalidades relacionadas. El servicio puede ser gratuito (con límites de uso) o de pago (suscripción «Premium»), según las condiciones publicadas en la sección correspondiente.
          </p>

          {/* ── 3. Condiciones de uso ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">3. Condiciones Generales de Uso</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            El acceso y uso de este sitio web atribuye la condición de «usuario» e implica la aceptación plena de las presentes condiciones legales. Si no estás de acuerdo con alguna de estas condiciones, te rogamos que no utilices el sitio.
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            El usuario se compromete a hacer un uso correcto del sitio web de conformidad con las leyes aplicables, el presente aviso legal, y las buenas costumbres generalmente aceptadas y el orden público.
          </p>

          {/* ── 4. Propiedad intelectual e industrial ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">4. Propiedad Intelectual e Industrial</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Todos los contenidos del sitio web, incluyendo a título enunciativo pero no limitativo textos, fotografías, gráficos, imágenes, iconos, tecnología, software, código fuente, diseño gráfico y demás elementos creativos, así como los nombres comerciales, marcas y signos distintivos, son propiedad de Good UX OÜ o de terceros que han autorizado su uso, y están protegidos por las normas nacionales e internacionales de propiedad intelectual e industrial.
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            Queda prohibida cualquier forma de reproducción, distribución, comunicación pública, transformación o cualquier otra forma de explotación de la totalidad o parte de los contenidos de este sitio web sin la autorización expresa y por escrito de Good UX OÜ.
          </p>

          {/* ── 5. Contenido generado por IA ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">5. Contenido Generado por Inteligencia Artificial</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Los planes de comidas, recetas, listas de la compra e imágenes generados por el servicio son producidos mediante modelos de inteligencia artificial de terceros (OpenAI, Anthropic, Google, Runware). Estos contenidos:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2">
            <li className="text-[16px] leading-[28px]">Tienen carácter <strong>orientativo y no constituyen asesoramiento médico, nutricional ni dietético</strong>.</li>
            <li className="text-[16px] leading-[28px]">Pueden contener inexactitudes. El usuario es responsable de verificar alergias, intolerancias y necesidades nutricionales específicas antes de consumir cualquier receta sugerida.</li>
            <li className="text-[16px] leading-[28px]">Las imágenes de los platos son generaciones artísticas; el resultado real puede diferir.</li>
          </ul>

          {/* ── 6. Exclusión de responsabilidad ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">6. Limitación de Responsabilidad</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Good UX OÜ no garantiza la disponibilidad continua e ininterrumpida del sitio web. En la medida permitida por la legislación aplicable, Good UX OÜ no será responsable de:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2">
            <li className="text-[16px] leading-[28px]">Interrupciones del servicio por causas de fuerza mayor, mantenimiento o actualizaciones técnicas.</li>
            <li className="text-[16px] leading-[28px]">Daños derivados del uso de la información proporcionada por los modelos de inteligencia artificial.</li>
            <li className="text-[16px] leading-[28px]">La exactitud de los precios estimados de productos; los precios reales dependen del establecimiento y momento de compra.</li>
            <li className="text-[16px] leading-[28px]">Contenidos o servicios de terceros accesibles mediante enlaces desde este sitio web.</li>
          </ul>

          {/* ── 7. Enlaces a terceros ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">7. Enlaces a Sitios de Terceros</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            El sitio web puede contener enlaces a sitios web de terceros. Good UX OÜ no controla ni se responsabiliza del contenido, políticas de privacidad o prácticas de dichos sitios. La inclusión de un enlace no implica asociación, aprobación ni garantía alguna respecto al sitio enlazado.
          </p>

          {/* ── 8. Legislación aplicable y jurisdicción ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">8. Legislación Aplicable y Jurisdicción</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Las presentes condiciones se rigen por la legislación española y de la Unión Europea. De conformidad con el Reglamento (UE) n.° 524/2013, informamos de que la Comisión Europea pone a disposición una plataforma de resolución de litigios en línea:
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#006600] underline">
              https://ec.europa.eu/consumers/odr
            </a>
          </p>
          <p className="text-[16px] leading-[28px] mb-4">
            Para cualquier controversia derivada de la interpretación o cumplimiento de este aviso legal, y sin perjuicio de los derechos que la normativa de consumidores y usuarios reconoce al consumidor, las partes se someterán a los juzgados y tribunales del domicilio del usuario, conforme a la normativa procesal española.
          </p>

          {/* ── 9. Contacto ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">9. Contacto</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            Para cualquier consulta relacionada con este aviso legal, puedes contactarnos en: <a href="mailto:hello@9meals.ai" className="text-[#006600] underline">hello@9meals.ai</a>
          </p>

        </div>
      </div>
    </div>
  );
}

export default AvisoLegal;
